/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
var contentStyles = css({
  display: 'inline-block',
  boxSizing: 'border-box',
  width: '100%',
  padding: "0 ".concat(gridSize() / 2, "px"),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  verticalAlign: 'top',
  whiteSpace: 'nowrap'
});
/**
 * __Content__
 *
 * Content to be shown in a lozenge
 */

var Content = function Content(_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children;
  return jsx("span", {
    style: {
      maxWidth: maxWidth
    },
    css: contentStyles
  }, children);
};

export default Content;